import useSWR from 'swr';
import { CONSTANTS } from '@/constants';
import { mergeAPIError } from '@/utils/errors';
import { request } from '@/utils/request';

interface ExtraEggsResponse {
  success: boolean;
  message: string;
  code: string;
  data: {
    unusedPaymentCount: number;
  };
}

async function fetchExtraEggs({ address }: { address: string }) {
  if (!address) {
    throw new Error('Invalid Address');
  }

  const search = new URLSearchParams();
  search.set('wallet', address);
  if (CONSTANTS.APP_ID) search.set('appId', CONSTANTS.APP_ID);

  const response = await request(
    `${CONSTANTS.BASE_URL}/api/world-coin-chest-smasher/extra-eggs/payment?${search.toString()}`,
  );

  if (!response.ok) {
    const msg = await response
      .json()
      .then((e) => mergeAPIError(e))
      .catch((e) => e.message ?? response.statusText);
    throw new Error(`Failed with status ${response.status} :${msg}`);
  }

  const data = await response.json();

  return data;
}

export function useChestNumber(address: string) {
  const data = useSWR<ExtraEggsResponse>(
    { key: 'extra-eggs', address: address },
    fetchExtraEggs,
    {
      dedupingInterval: 10000,
      revalidateOnFocus: false,
    },
  );

  return data;
}
